import { render, staticRenderFns } from "./AudienceIndex.vue?vue&type=template&id=0c59a65f&"
import script from "./AudienceIndex.vue?vue&type=script&lang=js&"
export * from "./AudienceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports